import { render, staticRenderFns } from "./stockTopMenu.vue?vue&type=template&id=663db9be&scoped=true"
import script from "./stockTopMenu.vue?vue&type=script&lang=js"
export * from "./stockTopMenu.vue?vue&type=script&lang=js"
import style0 from "./stockTopMenu.vue?vue&type=style&index=0&id=663db9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663db9be",
  null
  
)

export default component.exports